// extracted by mini-css-extract-plugin
export default {"legalText":"RBLOfferConfigurationView_legalText","estimatedSummary":"RBLOfferConfigurationView_estimatedSummary"};